export function FinanceErrorBanner({ message }: { message: string }) {
  return (
    <div
      className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-900/50 dark:bg-amber-950/40 dark:text-amber-100"
      role="alert"
    >
      {message}
    </div>
  );
}

export function FinanceStatusBadge({ status }: { status?: string | null }) {
  const s = (status || "draft").toLowerCase();
  const tone =
    s === "paid"
      ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200"
      : s === "void"
        ? "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300"
        : s === "sent" || s === "partial"
          ? "bg-blue-100 text-blue-800 dark:bg-blue-950/50 dark:text-blue-200"
          : "border border-slate-200 bg-white text-slate-700 dark:border-white/15 dark:bg-slate-900 dark:text-slate-300";
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium capitalize ${tone}`}>{s}</span>
  );
}

export function financeStatusIsOpen(status?: string | null) {
  const s = (status || "").toLowerCase();
  return s !== "void" && s !== "paid";
}
